module.exports = __webpack_public_path__ + "img/napoleons_hat.072a2de4.jpg";